<footer class="shadow">
  <div class="container-lg p-5">
    <div class="row">
      <div class="col-md-4">
        <img src="../../../assets/img/logoo.svg" alt="registered" class="cursor-pointer btn" class="header-img">
      </div>
      <div class="col-md-4">
        <p class=" fs-5 text-black fw-semibold">Social Media</p>
        <span>
          <a class="text-black fs-6" href="https://www.facebook.com/profile.php?id=61565877611650#">
            <img src="../../../assets/img/home/facebook.svg" alt="facebook" width="30" loading="lazy">
            Facebook
          </a>
        </span>
        <span class="ms-3">
          <a class="text-black fs-6" href="https://www.facebook.com/profile.php?id=61565877611650#">
            <img src="../../../assets/img/home/instagram.svg" alt="instagram" width="30" loading="lazy">
            Instagram
          </a>
        </span>
      </div>
      <div class="col-md-4">
        <p class="fs-5 text-black fw-semibold">Contact</p>
        <span class="text-black fs-6 d-flex align-items-center mb-2">
          <span class="material-symbols-outlined me-2 fs-6">
            mail
          </span>
          Email: <a class="text-black" href="mailto:sales@cixcent.com">info@cixcent.com</a>
        </span>
        <span class="text-black fs-6 d-flex align-items-center mb-2">
          <span class="material-symbols-outlined me-2 fs-6">
            call
          </span>
          Phone: 040 4515 7722
        </span>
        <span class="text-black fs-6 d-flex align-items-sm-start mb-2">
          <span class="material-symbols-outlined me-2 fs-6 mt-1">
            location_on
          </span> Address: Sainikpuri, Hyderabad,
          Telangana - 500094
        </span>
      </div>
    </div>
  </div>

<hr class="text-white border-top-2 border-white-800">
<div class="bg-white border-top">
  <div class="container-lg py-4">
    <div class="row align-items-center text-center text-md-start">
      
      <div class="col-10 text-center">
        <span class="text-black text-center small d-block" style="font-size: 14px;">
          © 2025 All Rights Reserved by Cixcent Technologies Private Limited
        </span>
      </div>

      <div class="col-2 text-md-end">
        <a href="#" class=" text-muted text-decoration-none me-2 small">Terms of Use</a>|
        <a (click)="openPrivacyPolicy()" class=" text-muted text-decoration-none ms-2 small">Privacy Policy</a>
      </div>

    </div>
  </div>
</div>
